import routes from "./routes";

import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";

function App() {
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.route) {
        return (
          <Route
            basename="makeorder"
            exact
            path={route.route}
            loader={() => {
              if (route?.loader && typeof route?.loader == "function")
                return route?.loader();
              else return false;
            }}
            element={route.component}
            key={route.key}
          />
        );
      }
      return null;
    });
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/makeorder" />} />
      </>
    )
  );
  return <RouterProvider router={router} />;
}

export default App;
